module.exports = __webpack_public_path__ + "static/media/institute-2-min.b49681b5.webp";